import { ChatFile, ChatMessage, ChatSession, SocketChatSession } from "./chat";
import { ChatChoice } from "./chatChoice";
import { LiveChatData } from "./client";
import { UserId } from "./common";
import { PromptEvalStartPayload, PromptEvalStatusPayload } from "./promptEval";

export interface SocketMessage {
  session?: SocketChatSession | null | undefined;
  socket: SocketType;
  message?: ChatMessage | null | undefined;
  history?: ChatSession[] | null | undefined;
  senderId?: UserId | null | undefined;
  timestamp: Date;
  chatData?: LiveChatData | null | undefined;
  uploadedFiles?: ChatFile[] | null | undefined;
  readMessages?: ChatMessage[] | null | undefined;
  /** Bot SYSTEM reply may include prompt-linked choices for the customer. */
  choices?: ChatChoice[] | null | undefined;
  /**
   * Top-level Prompt Eval field (not under `message`):
   * - Start: `{ suiteId }`
   * - Status: `{ suiteId, runIds, status, ... }`
   */
  promptEval?: PromptEvalStartPayload | PromptEvalStatusPayload | null | undefined;
}

export interface SocketError {
  error: string;
}

export enum SocketType {
  DEFAULT = 'Default',
  MESSAGE = 'Message',
  SYSTEM = 'System',
  NOTIFY = 'Notify',
  REQUEST = 'Request',
  ASSIGN = 'Assign',
  ASSIGNED = 'Assigned',
  READ = 'Read',
  TYPING = 'Typing',
  CHATENDED = 'ChatEnded',
  CHATCLOSED = 'ChatClosed',
  CHATRECEIVED = 'ChatReceived',
  RELOAD = 'Reload',
  REPORT_LIVE_CHAT_SESSIONS = 'ReportLiveChatSessions',
  REPORT_PROMPT_EVAL_RUNS = 'ReportPromptEvalRuns',
  INACTIVITY_MESSAGE_STATUS = 'InactivityMessageStatus',
  PROMPTEVALSTART = 'PromptEvalStart',
  PROMPTEVALSTATUS = 'PromptEvalStatus'
}